import React from 'react';
import { createComponent } from '@lit/react';
import { SDSPopover } from '../sds-popover/sds-popover';

export const SDSPopoverWrapper = createComponent({
	tagName: 'sds-popover',
	elementClass: SDSPopover,
	react: React,
	events: {},
});
